import { OperatorFunction } from 'rxjs';
import { map } from 'rxjs/operators';

export function not(): OperatorFunction<unknown, boolean> {
  return map(x => !x);
}
